import { render, staticRenderFns } from "./resource-table.vue?vue&type=template&id=59cbc985&scoped=true&"
import script from "./resource-table.vue?vue&type=script&lang=js&"
export * from "./resource-table.vue?vue&type=script&lang=js&"
import style0 from "./resource-table.vue?vue&type=style&index=0&id=59cbc985&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cbc985",
  null
  
)

export default component.exports